import React, { Component } from "react";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "datatables.net-dt/css/jquery.dataTables.css";
import "jspdf-autotable";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";

const $ = require("jquery");
const jzip = require("jzip");
window.JSZip = jzip;
$.DataTable = require("datatables.net-bs4");
$.DataTable = require("datatables.net-responsive-bs4");
$.DataTable = require("datatables.net");
require("datatables.net-buttons/js/dataTables.buttons.min");
require("datatables.net-buttons/js/buttons.html5.min");

export default class PetrolDetailDataTable extends Component {
  componentDidMount() {
    this._setTableData();

    if (!this.props.hideAction) {
      const that = this;
      $("#dataTables-petrolDetails").on("click", "#toRemove", function () {
        let data = $(this).find("#remove").text();
        data = JSON.parse(data);

        that.props.onRemoveDetail(data);
      });
      $("#dataTables-petrolDetails").on("click", "#toEdit", function () {
        let data = $(this).find("#edit").text();
        data = JSON.parse(data);

        that.props.onEditDetail(data);
      });
    }
  }

  componentDidUpdate() {
    this._setTableData();
  }

  totalKm(end_mileage, start_mileage) {
    return end_mileage - start_mileage;
  }

  companyUsedKm(totalKm, personal_use_km) {
    return totalKm - personal_use_km;
  }

  totalAmount(companyUsedKm) {
    return companyUsedKm * this.props.amountPerKm;
  }

  _setTableData() {
    let table;
    let list = [];
    let obj,
      one = [];

    let petrolDetailsData = this.props.petrolDetailsData;

    for (let i = 0; i < petrolDetailsData.length; i++) {
      obj = petrolDetailsData[i];

      const totalKm = this.totalKm(obj.end_mileage, obj.start_mileage);
      const companyUsedKm = this.companyUsedKm(totalKm, obj.personal_use_km);

      one = {
        no: i + 1,
        petrol_application_detail_id: obj.petrol_application_detail_id,
        actual_date: obj.actual_date,
        start_location: obj.start_location,
        destination: obj.destination,
        trip_type: obj.trip_type.label,
        start_mileage: obj.start_mileage,
        end_mileage: obj.end_mileage,
        total_km: obj.total_km ?? totalKm,
        personal_use_km: obj.personal_use_km,
        company_use_km: obj.company_use_km ?? companyUsedKm,
        amount: this.props.recalculateAmount
          ? this.totalAmount(companyUsedKm)
          : obj.amount ?? this.totalAmount(companyUsedKm),
        purpose: obj.purpose,
        remark: obj.remark,
        action: this.props.hideAction
          ? undefined
          : '<button style="margin-right:10px" class="btn btn-danger btn-sm own-btn-edit" id="toRemove" ><span id="remove" class="hidden" >' +
            i +
            '</span>  <i className="fa fa-cogs"></i>&nbsp;Remove</button>' +
            '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toEdit" ><span id="edit" class="hidden" >' +
            i +
            '</span>  <i className="fa fa-cogs"></i>&nbsp;Edit</button>',
      };

      list.push(one);
    }

    if ($.fn.dataTable.isDataTable("#dataTables-petrolDetails")) {
      table = $("#dataTables-petrolDetails").dataTable();
      table.fnClearTable();
      table.fnDestroy();
      $("#dataTables-petrolDetails").empty();
    }

    let column = [
      { title: "No", data: "no" },
      { title: "Actual Date", data: "actual_date" },
      { title: "Start Location", data: "start_location" },
      { title: "Destination", data: "destination" },
      { title: "Trip Type", data: "trip_type" },
      { title: "Start Mileage", data: "start_mileage" },
      { title: "End Mileage", data: "end_mileage" },
      { title: "Total (km)", data: "total_km" },
      { title: "Personal Used (km)", data: "personal_use_km" },
      { title: "Company Used (km)", data: "company_use_km" },
      { title: "Amount", data: "amount" },
      { title: "Purpose", data: "purpose" },
      { title: "Remark", data: "remark" },
    ];
    if (!this.props.hideAction) {
      column.push({ title: "Action", data: "action" });
    }

    const editingPetrolDetailId = this.props.editingDetailId;

    table = $("#dataTables-petrolDetails").DataTable({
      pageLength: 20,
      autofill: true,
      bLengthChange: false,
      bInfo: false,
      responsive: true,
      paging: true,
      searching: false,
      dom: "Bfrtip",
      buttons: ["copy", "csv", "excel", "pdf"],
      data: list,
      columns: column,
      createdRow: (row, data, dataIndex) => {
        if (data.petrol_application_detail_id === editingPetrolDetailId) {
          $(row).css("background-color", " #61dafb");
        }
      },
    });
  }

  render() {
    return (
      <div>
        <div className="margin-y">
          <table
            width="99%"
            className="table table-striped table-bordered table-hover table-responsive nowrap dt-responsive rm-marginTop"
            id="dataTables-petrolDetails"
          ></table>
        </div>
      </div>
    );
  }
}
